import {z} from 'zod';
import {tradeTagDbSchema} from './tradeTagDbSchema';

export const tradeTagSchema = tradeTagDbSchema.extend({
  id: z.string(),
});

export type TradeTag = z.infer<typeof tradeTagSchema>;
